import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgxExpiringLicenseComponent } from './expiring-license.component';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		MatTooltipModule
	],
	declarations: [
		NgxExpiringLicenseComponent
	],
	exports: [
		NgxExpiringLicenseComponent
	],
	providers: [
		TranslatePipe
	]
})
export class ExpiringLicenseModule {}
